import {useEffect} from "react";
import {legalDocs} from "../../../generated/legal";
import NotFound from "../../NotFound";

export default function LegalPage({slug}: { slug: string }) {
    const doc = legalDocs[slug];

    useEffect(() => {
        if (doc) document.title = `${doc.title} - Rust Server Tool`;
    }, [doc]);

    if (!doc) return <NotFound/>;

    return (
        <div className="w-full max-w-4xl mx-auto flex-grow sm:pt-12 px-6 md:px-10">
            <section className="py-12 md:py-16">
                <header className="mb-10 border-b border-neutral-800 pb-8">
                    <h1 className="text-4xl md:text-5xl font-bold text-white tracking-tight">
                        {doc.title}
                    </h1>
                    {doc.lastUpdated && (
                        <p className="mt-3 text-sm text-neutral-400">
                            Last updated: {doc.lastUpdated}
                        </p>
                    )}
                </header>

                <article
                    className="legal-content"
                    dangerouslySetInnerHTML={{__html: doc.html}}
                />
            </section>
        </div>
    );
}
